import axios from 'axios';

export default {
	getInitData(data) {
		return axios.post('/apps/lahi/api/init', data);
	},
	calculate(data) {
		return axios.post('/apps/lahi/api/calculate', data);
	},
	getLahiProductJson(lahiId, path) {
		return axios.get(`${path}${lahiId}.json`);
	},
	selectLahiLoan(data) {
		return axios.post('/apps/lahi/api/select', data);
	},
	postEmailForm(data) {
		return axios.post('/apps/lahi/api/email', data);
	},
	sendTa(data) {
		return axios.post('/apps/lahi/api/ta', data);
	}
};
